import React from 'react';
import SplashScreen from '../components/SplashScreen';

const Splash = () => (
  <>
    <SplashScreen />
  </>
);

export default Splash;
